<template>
  <mdb-view class="public-landing overflow-auto view-gp-back">
    <mdb-mask class="gp-hp-gradient overflow-auto">
      <mdb-container class="gp-intro">

        <div class="text-center text-white gp-has-header h1">
          Ezumee Meeting Up Groups
        </div>

        <div class="text-center text-white h4">
          <i>Time For Real Change</i>
        </div>

        <div class="text-center text-white h3 mt-5">
          Ready to Get Started?
        </div>
        <mdb-btn color="white" icon="sign-in" @click="$router.push('/login')">Login</mdb-btn>
        <mdb-btn color="white" icon="user-plus" @click="$router.push('/register')">Register</mdb-btn>

        <div class="text-center text-white h3 mt-5">
          Want to see what's here?
        </div>
        <mdb-btn color="white" icon="telescope" @click="$router.push('/explore')">Explore Groups</mdb-btn>

      </mdb-container>
    </mdb-mask>
  </mdb-view>

</template>

<script>
import {mdbBtn, mdbCard, mdbCardBody, mdbContainer, mdbIcon, mdbMask, mdbView} from 'mdbvue';

export default {
  name: 'ezumee-public-home',
  components: {
    mdbCard,
    mdbCardBody,
    mdbBtn,
    mdbIcon,
    mdbView,
    mdbMask,
    mdbContainer
  },
  methods: {
    moreInfo() {
      window.open(process.env.PUBLIC_HOME)
    }
  }
}
</script>
<style scoped>
.public-landing {
  background-image: url("https://static.ezumee.com/group-jump.png");
}
.view-gp-back {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: calc(100vh);
  overflow: auto;
}

.gp-hp-gradient {
  background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.5), rgba(29, 210, 177, 0.5) 100%);
  background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.5), rgba(29, 210, 177, 0.5) 100%);
  background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.5), rgba(29, 210, 177, 0.5) 100%);
  background: linear-gradient(45deg, rgba(42, 27, 161, 0.5), rgba(29, 210, 177, 0.5) 100%);
}

</style>
